export default __webpack_public_path__ + "static/media/experts2.0143e30d.jpg";